import React, { useEffect } from "react";
import SharedLayouts from "../Layouts/SharedLayout";
import { Link, useNavigate } from "react-router-dom";
import * as General from '../General/General';
import { HiCollection, HiTruck, HiInformationCircle, HiArrowLeft, HiOutlineTag, HiOutlineMail } from "react-icons/hi";
import { HiNewspaper, HiMapPin } from "react-icons/hi2";
import { TbLicense } from "react-icons/tb";
import { GrGallery } from "react-icons/gr";
import { ImFileText2 } from "react-icons/im";
import { LiaPagerSolid } from "react-icons/lia";

const sections = [
    {
        title: "محصولات",
        description: "افزودن، ویرایش و حذف دسته‌بندی محصولات و تصویر هر دسته",
        to: "/product",
        icon: HiCollection,
    },
    {
        title: "پروژه‌ها",
        description: "مدیریت لیست پروژه‌های انجام‌شده، کارفرما، وضعیت و تصاویر هر پروژه",
        to: "/project",
        icon: HiTruck,
    },
    {
        title: "ارتباطات",
        description: "ویرایش شماره تماس، ایمیل، آدرس و لینک شبکه‌های اجتماعی نمایش داده‌شده در فوتر سایت",
        to: "/contactInfo",
        icon: HiInformationCircle,
    },
    {
        title: "استاندارد و گواهی‌نامه‌ها",
        description: "افزودن و ویرایش گواهی‌نامه‌ها و استانداردهای شرکت به همراه تصویر و توضیحات",
        to: "/license",
        icon: TbLicense,
    },
    {
        title: "گالری تصاویر",
        description: "مدیریت تصاویری که در گالری وب‌سایت به نمایش گذاشته می‌شوند",
        to: "/Gallery",
        icon: GrGallery,
    },
    {
        title: "متون ثابت وب‌سایت",
        description: "ویرایش متن‌های ثابت بخش‌های مختلف سایت، مانند درباره ما و توضیحات صفحات",
        to: "/Text",
        icon: ImFileText2,
    },
    {
        title: "لندینگ پیج",
        description: "مدیریت اسلایدهای صفحه اصلی سایت شامل تصویر، عنوان و متن هر اسلاید",
        to: "/MainPage",
        icon: LiaPagerSolid,
    },
    {
        title: "دسته‌بندی مقالات",
        description: "افزودن، ویرایش و حذف دسته‌بندی‌های مقالات",
        to: "/ArticleCategory",
        icon: HiOutlineTag,
    },
    {
        title: "مقالات",
        description: "مدیریت مقالات سایت شامل عنوان، خلاصه، متن کامل، تصویر و وضعیت انتشار",
        to: "/Article",
        icon: HiNewspaper,
    },
    {
        title: "موقعیت‌های نقشه",
        description: "مدیریت شعبه‌ها و موقعیت‌های نمایش داده‌شده روی نقشه صفحه تماس با ما",
        to: "/MapLocations",
        icon: HiMapPin,
    },
    {
        title: "پیام‌های تماس",
        description: "مشاهده و مدیریت پیام‌های ارسال‌شده از فرم تماس با ما",
        to: "/ContactMessages",
        icon: HiOutlineMail,
    },
];

const Dashboard = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!General.isLoggedIn()) {
            navigate('/');
        }
    }, []);

    const user = General.getAuthUser();

    return (
        <SharedLayouts>
            <div className="w-full h-full p-6 overflow-y-auto">
                <div className="mb-8">
                    <h1 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
                        <span className="wave-emoji text-3xl">👋</span>
                        <span>
                            {user?.username ? `خوش آمدید، ${user.username}` : "خوش آمدید"}
                        </span>
                    </h1>
                    <p className="text-gray-500 mt-1">
                        از هر یک از بخش‌های زیر می‌توانید محتوای مربوط به همان بخش از وب‌سایت را مدیریت کنید.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {sections.map(({ title, description, to, icon: Icon }) => (
                        <Link
                            key={to}
                            to={to}
                            className="group bg-white rounded-xl border border-gray-200 p-5 flex flex-col shadow-sm hover:shadow-md hover:border-cyan-300 transition-all duration-200"
                        >
                            <div className="w-12 h-12 rounded-lg bg-cyan-50 flex items-center justify-center mb-4 group-hover:bg-cyan-100 transition-colors">
                                <Icon size={24} className="text-cyan-600" />
                            </div>
                            <h2 className="text-base font-semibold text-gray-800 mb-1">
                                {title}
                            </h2>
                            <p className="text-sm text-gray-500 leading-relaxed flex-grow">
                                {description}
                            </p>
                            <div className="mt-4 flex items-center text-cyan-600 text-sm font-medium">
                                <span>ورود به این بخش</span>
                                <HiArrowLeft className="mr-2 transform transition-transform group-hover:-translate-x-1" />
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </SharedLayouts>
    );
}

export default Dashboard;
